import { render, staticRenderFns } from "./AdminReopenAllSitesButton.vue?vue&type=template&id=28dfa07a"
import script from "./AdminReopenAllSitesButton.vue?vue&type=script&lang=js"
export * from "./AdminReopenAllSitesButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports